import { IconPageBreak } from '@tabler/icons-react';

import { ActionIcon, Menu, Tooltip } from '@mantine/core';

import { getBlockPluginsByCategory } from '../core/BlockPluginRegistry';
import { useEditorAdapter } from '../core/EditorAdapterContext';

const InsertBreakButton = ({ disabled }: { disabled?: boolean }) => {
    const adapter = useEditorAdapter();
    const breakPlugins = getBlockPluginsByCategory('break');

    return (
        <Menu shadow="md">
            <Menu.Target>
                <Tooltip
                    label="Insert Break"
                    position="top"
                    offset={8}
                    styles={{
                        tooltip: {
                            zIndex: 2,
                            borderRadius: '0.375rem',
                            padding: '0.25rem 0.5rem',
                            fontSize: '0.75rem',
                            backgroundColor: '#B0B4BA',
                            color: '#111113'
                        }
                    }}
                >
                    <ActionIcon variant="subtle" color="gray" style={{ color: 'var(--mantine-color-text)', opacity: disabled ? 0.25 : 1, pointerEvents: disabled ? 'none' : undefined }}>
                        <IconPageBreak />
                    </ActionIcon>
                </Tooltip>
            </Menu.Target>
            <Menu.Dropdown>
                {breakPlugins.map((plugin) => (
                    <Menu.Item
                        key={plugin.name}
                        onClick={() => adapter.insertBlock(plugin.name)}
                    >
                        {plugin.displayName}
                    </Menu.Item>
                ))}
            </Menu.Dropdown>
        </Menu>
    );
};

export default InsertBreakButton;
